import { Banner, Icon } from '@equinor/eds-core-react';
import { info_circle } from '@equinor/eds-icons';
import * as Styled from './FullPageBanner.styled';

/* eslint-disable camelcase */
Icon.add({ info_circle });

export function UnauthenticatedBanner() {
  return (
    <Styled.CenteredPage>
      <Banner>
        <Banner.Icon variant="info">
          <Icon name="info_circle" />
        </Banner.Icon>
        <Banner.Message>
          Redirecting you to sign in. Please wait…
        </Banner.Message>
      </Banner>
    </Styled.CenteredPage>
  );
}
